export default __webpack_public_path__ + "static/media/taxi-active.b0be3054.svg";